
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/p/[slug]",
      function () {
        return require("private-next-pages/default/desktop/p/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/p/[slug]"])
      });
    }
  